import { configureStore } from "@reduxjs/toolkit";
import { authenticationAPI } from "../services/authenticationAPI";
import userSlice from "./slices/user/userSlice";
import { matchAPI } from "../services/matchAPI";
import wicketTypeSlice from "./slices/outhow/wicketTypeSlice";
import { outHowApi } from "../services/outHowAPI";
import homeSlice from "./slices/home/homeSlice";
import { tournamentsApi } from "../services/tournamentsAPI";
import tournamentSlice from "./slices/tournaments/tournamentSlice";

export const store = configureStore({
  reducer: {
    [authenticationAPI.reducerPath]: authenticationAPI.reducer,
    [matchAPI.reducerPath]: matchAPI.reducer,
    [outHowApi.reducerPath]: outHowApi.reducer,
    [tournamentsApi.reducerPath]: tournamentsApi.reducer,
    user: userSlice,
    wicketTypes: wicketTypeSlice,
    home: homeSlice,
    tournaments: tournamentSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authenticationAPI.middleware,
      matchAPI.middleware,
      outHowApi.middleware,
      tournamentsApi.middleware
    ),
});
